module.exports = __webpack_public_path__ + "static/media/ceUSDC.3b5972c1.svg";